import { useQuery } from '@tanstack/react-query';
import { pickListApi, type PickListCode, type PickListItemDto } from '@/features/reports/api';

export const pickListQueryKeys = {
  all: ['pick-list'] as const,
  byCode: (code: string) => [...pickListQueryKeys.all, 'by-code', code] as const,
};

/** GET /api/app/pick-list/pick-list-by-code-select-item?Code=… — cached per code, never reloads in a session. */
export function usePickListQuery(code: PickListCode | string | null | undefined) {
  const trimmed = typeof code === 'string' ? code.trim() : '';
  const enabled = trimmed.length > 0;
  return useQuery<PickListItemDto[]>({
    queryKey: pickListQueryKeys.byCode(trimmed),
    queryFn: () => pickListApi.getByCode(trimmed),
    enabled,
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });
}
